'use strict';

const planDurations = require( 'ck-core/source/data/planDurations' );

module.exports = require( 'ck-core/source/functions/makeLang' )( {
	ONE_OFF: 'One time payment. 30-day refund policy once you start coding.',
	[ planDurations.MONTHLY ]: 'Billed monthly. Cancel anytime.<br><br>',
	[ planDurations.THREE_MONTHLY ]: 'Billed every 3 months. Cancel anytime.',
	[ planDurations.YEARLY ]: 'Billed annually. Cancel anytime. 30-day refund policy once you start coding.',

	FAMILY_SUFFIX: ' - Family',

	EQUIVALENT_TO: 'Equivalent to ',

	TRIAL: {
		NAME: 'Free Preview',
		DESCRIPTION: 'Code your first game course for free!'
	}
} );
